import { Link } from 'gatsby'
import React, { useState, useCallback } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import Articles from './articles'

const Sidebar = ({ siteMetadata }) => {
  const [initStyle, setInitStyle] = useState(true)
  const updateStyle = useCallback(() => setInitStyle(false))

  return (
    <>
      <aside className="sidebar">
        <header>
          <div className="about">
            <div className="cover-author-image">
              <Link to="/">
                <StaticImage src="./pic2.png" alt={siteMetadata.author} />
              </Link>
            </div>
            <div className="author-name">{siteMetadata.author}</div>
            <p className="author-description">{siteMetadata.description}</p>
          </div>
          <section className="certs">
            <StaticImage src="./mct.png" alt="MCT" />
            <StaticImage src="./az-architect.png" alt="Azure Architect" />
          </section>
          <section className="award">
            <Link to="https://mvp.microsoft.com/en-us/PublicProfile/5005172?fullName=Marcel%20Medina">
              <StaticImage
                src="mvp.png"
                alt="Microsoft MVP"
                formats={['AUTO', 'WEBP']}
                quality={100}
              />
            </Link>
          </section>
        </header>
        <section className="articles">
          <h3 className="recent-posts-title">Recent Posts</h3>
          <Articles onUpdate={updateStyle} />
        </section>
        <footer>
          <section className="contact">
            <h3 className="contact-title">Contact</h3>
            <ul>
              {siteMetadata.social.email && (
                <li>
                  <a
                    href={`mailto:${siteMetadata.social.email}`}
                    target="_blank"
                  >
                    <i className="fa fa-envelope-o" aria-hidden="true" />
                  </a>
                </li>
              )}
              {siteMetadata.social.twitter && (
                <li>
                  <a
                    href={`https://twitter.com/${siteMetadata.social.twitter}`}
                    target="_blank"
                  >
                    <i className="fa fa-twitter" aria-hidden="true" />
                  </a>
                </li>
              )}
              {siteMetadata.social.instagram && (
                <li>
                  <a
                    href={`https://www.instagram.com/${siteMetadata.social.instagram}`}
                    target="_blank"
                  >
                    <i className="fa fa-instagram" aria-hidden="true" />
                  </a>
                </li>
              )}
              {siteMetadata.social.facebook && (
                <li>
                  <a
                    href={`https://facebook.com/${siteMetadata.social.facebook}`}
                    target="_blank"
                  >
                    <i className="fa fa-facebook" aria-hidden="true" />
                  </a>
                </li>
              )}
              {siteMetadata.social.github && (
                <li>
                  <a
                    href={`https://github.com/${siteMetadata.social.github}`}
                    target="_blank"
                  >
                    <i className="fa fa-github" aria-hidden="true" />
                  </a>
                </li>
              )}
              {siteMetadata.social.linkedin && (
                <li>
                  <a
                    href={`https://linkedin.com/in/${siteMetadata.social.linkedin}`}
                    target="_blank"
                  >
                    <i className="fa fa-linkedin" aria-hidden="true" />
                  </a>
                </li>
              )}
            </ul>
          </section>
          <div className="copyright">
            <p>
              {new Date().getFullYear()} &copy; {siteMetadata.company}
            </p>
          </div>
        </footer>
      </aside>
    </>
  )
}

export default Sidebar
